import { render } from "./SectionTitle.vue?vue&type=template&id=1b9f24be"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/SectionTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b9f24be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b9f24be', __exports__)) {
    api.reload('1b9f24be', __exports__)
  }
  
  module.hot.accept("./SectionTitle.vue?vue&type=template&id=1b9f24be", () => {
    api.rerender('1b9f24be', render)
  })

}


export default __exports__